import { enableProdMode } from "@angular/core";
enableProdMode();
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { APP_ROUTER_PROVIDERS } from './app.routes';
import { createAppModule } from './app.module';
//Webpack
window["run"] = function (param: any) {
    platformBrowserDynamic().bootstrapModule(createAppModule(param));
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/main.ts